import { Alert } from "@mui/material";
import { SxProps } from "@mui/system";
import React from "react";

import { formatEquivalentColors } from "../../tools";

export interface EquivalentColorsSet {
  system: string;
  color: string;
  // the colors confirmed equivalent to `color`, `color` itself left out
  equivalentColors: string[];
}

// A pricing scheme is queried for one color but priced from that color and its confirmed
// equivalents, so its stones are not all the color it is labelled with. Say so wherever such a
// pricing is shown, so the numbers are not read as coming from the asked-for color alone. Renders
// nothing when the color has no equivalent — the common case — so callers can drop it in
// unconditionally.
const EquivalenceAlert = ({
  equivalentColors,
  sx,
}: {
  equivalentColors: EquivalentColorsSet | null | undefined;
  sx?: SxProps;
}) => {
  if (!equivalentColors) return null;

  const others = formatEquivalentColors(equivalentColors);
  if (others.length === 0) return null;

  return (
    <Alert severity="info" sx={sx}>
      Diamonds of the equivalent color{others.length > 1 ? "s" : ""}{" "}
      {others.join(", ")} were also included in this pricing.
    </Alert>
  );
};

export default EquivalenceAlert;
